import React from 'react'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
const dnacompatibility = () => {
  return (
    <div>
      <Header />
      <section class="banner bannerblue">
        <div class="banner-blk">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-7">
                <div class="content-blk">
                  <div class="hero-eyebrow">
                    <span claclassnamess="hero-dot"></span>
                    <span class="overline">FutureSoulmates™ · Patent-Protected AI + DNA Platform</span>
                  </div>
                  <h1 class="disp-xl">One saliva sample.<br /><em class="indigo">A lifetime of insight.</em></h1>
                  <p class="body-lg">Your genome carries the blueprint of who you are — your immune system, your personality predispositions, your capacity to raise a healthy family. FutureSoulmates reads it so you don't have to spend years discovering it through trial and error.</p>
                  <div class="hero-btns"><button class="btn btn-indigo">Get My DNA Kit
                    →<span class="arr">→</span></button></div>
                </div>
              </div>
              <div className="col-md-5">
                <div class="hero-img-stack">
                  <img alt="" src="/images/dnacompatibility-banner.jpg" />

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="sec sec-white">
        <div class="sec-label"><span class="overline" >What 1,520 genes reveal</span></div>
        <h2 class="disp-md">Six domains of compatibility.<br />None of them are guesswork.</h2>

        <div class="domain-grid">
          <div class="domain" >
            <div class="domain-icon">💛</div>
            <h4>Psychogenetic</h4>
            <div class="domain-genes">OXTR · AVPR1A · SLC6A4 · MAOA · COMT · DRD4</div>
            <p>Oxytocin receptor, attachment style, serotonin transport, reward circuitry. The genetic architecture of how you love — and whether your styles are compatible.</p>
          </div>
          <div class="domain">
            <div class="domain-icon">🛡️</div>
            <h4>Immune Compatibility</h4>
            <div class="domain-genes">HLA-A · HLA-C · KIR2DL1 · KIR3DL1 · HLA-G</div>
            <p>HLA/KIR immunogenetic matching. Predicts implantation success, preeclampsia risk, and gestational tolerance. The immune system's verdict on your genetic pairing.</p>
          </div>
          <div class="domain">
            <div class="domain-icon">💙</div>
            <h4>Cardiovascular</h4>
            <div class="domain-genes">ACE · MYBPC3 · SCN5A · MYH7 · APOE</div>
            <p>Cardiac structure, arrhythmia predisposition, hypertension genetic loading. Relevant for long-term health compatibility and the cardiac monitoring module.</p>
          </div>
          <div class="domain">
            <div class="domain-icon">👶</div>
            <h4>Reproductive Safety</h4>
            <div class="domain-genes">BRCA1/2 · MTHFR · CFTR · SMN1 · 300+ carrier genes</div>
            <p>Carrier status across 300+ inheritable conditions. Know your carrier risk overlap before you start trying — not after two years of trying.</p>
          </div>
          <div class="domain">
            <div class="domain-icon">🧠</div>
            <h4>Cognitive & Career Fit</h4>
            <div class="domain-genes">BDNF · COMT · DRD4 · FOXP2 · CACNA1C</div>
            <p>Cognitive style, stress reactivity, creativity, chronotype. Knowing whether you're both night owls, whether you process stress similarly — these predict relationship harmony.</p>
          </div>
          <div class="domain">
            <div class="domain-icon">⏳</div>
            <h4>Longevity & Lifestyle</h4>
            <div class="domain-genes">FOXO3 · TERT · SIRT1 · APOE · PER1/2/3</div>
            <p>Cellular ageing rate, circadian rhythm genetics, mitochondrial function. Build a life with someone whose body ages and functions on a compatible timeline.</p>
          </div>
        </div>
      </div>



      <div class="sec sec-blush">
        <div class="row split">
          <div class="col-md-6">
            <img src="https://images.unsplash.com/photo-1576671414121-aa2f69a26aa8?w=600&amp;q=80" alt="DNA testing in laboratory" loading="lazy" />
          </div>
          <div class="col-md-6">
            <div class="sec-label"><span class="overline"  >The process</span></div>
            <h2 class="disp-md">From saliva to soulmate<br />in under 4 weeks.</h2>
            <div class="tl">
              <div class="tl-item"><div class="tl-dot" ></div><div class="tl-yr"  >WEEK 1</div><div class="tl-txt">DNA kit arrives. Saliva collection takes 5 minutes. Return envelope pre-paid. Chain-of-custody authentication on every sample (patent filed — DNA CIP Claim 3).</div></div>
              <div class="tl-item"><div class="tl-dot" ></div><div class="tl-yr"  >WEEKS 2–3</div><div class="tl-txt">1,520-gene panel sequenced by our CLIA-certified lab partner. Polygenic scoring algorithms compute your normalised trait vectors across all six domains.</div></div>
              <div class="tl-item"><div class="tl-dot" ></div><div class="tl-yr"  >WEEK 4</div><div class="tl-txt">Your compatibility profile is ready. Complete the 40-minute psychometric assessment. Your matches surface with Total Compatibility Scores computed before you ever see their photo.</div></div>
              <div class="tl-item"><div class="tl-dot"></div><div class="tl-yr">ONGOING</div><div class="tl-txt">Your profile updates with every biometric session. The more data, the more precise your matches become over time.</div></div>
            </div>
            <div class="pat"><div class="pat-icon">⚖️</div><div class="pat-txt"><strong>Patent on the fusion:</strong> U.S. App. 19/407,993 and its CIP cover the multimodal fusion of genetic trait vectors with wearable biometric time-series to generate personalised compatibility embeddings. 1,520 genes in Appendix A. 10 independent claims. 60 dependent claims.</div></div>
          </div>
        </div>
      </div>

      <div>
        <section class="trusted-story">
          <div class="container p-0">
            <div class="cta-sec cta-coral">
              <h2 class="disp-md">Your DNA already knows who you're compatible with.</h2>
              <p>Let us show you who that is. DNA kit ships Q3 2026.</p>
              <div class="cta-btns">
                <button class="btn btn-white">Get My DNA Kit <span class="arr">→</span></button>
                <button class="btn investerbtn">Family Planning →</button>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  )
}

export default dnacompatibility
